import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/layer/history/layer.history.query.gql"
import type {
  LayerHistoryQuery,
  LayerHistoryQueryVariables,
} from "@/v2-backoffice-client/layer/history/__types__/layer.history.query"

type Options = QueryHookOptions<LayerHistoryQuery, LayerHistoryQueryVariables>

export function useLayerHistoryQuery(options?: Options) {
  return useQuery<LayerHistoryQuery, LayerHistoryQueryVariables>(query, options)
}
